import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import React, {useState} from 'react'
import {IReleases, ReleasesInitValues as initialValues} from '../../models/ReleasesModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import {useIntl} from 'react-intl'
import HeaderCard from '../../../../../../components/Forms/HeaderCard'
import {Input} from '../../../../../../components/Forms/Input'

const API_URL = process.env.REACT_APP_API_URL || 'api'

const ReleasesSchema = Yup.object().shape({
  product_name: Yup.string().required('Campo obrigatório'),
  release_version: Yup.string().required('Campo obrigatório'),
  overview: Yup.string().required('Campo obrigatório'),
})

const FormReleasesAdd: React.FC = () => {
  // eslint-disable-next-line
  const [uuid, setUuid] = useState('')
  const intl = useIntl()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const resp = localStorage.getItem('auth_storage')
  let token = ''
  if (resp) {
    token = JSON.parse(resp)
  }
  let config = {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  }

  const formik = useFormik<IReleases>({
    initialValues,
    validationSchema: ReleasesSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        await axios.post(API_URL + '/v1/releases' + uuid, values, config)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'RELEASE.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/releases')
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'RELEASE.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 1500,
        })

        setLoading(false)
      }
    },
  })
  function resetInputs() {
    formik.resetForm()
  }

  return (
    <div className='card card-custom mt-n8'>
      {/* Component Header de Cadastros. */}
      <HeaderCard
        buttonBack={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})}
        title={intl.formatMessage({id: 'RELEASES.NEW_RELEASES'})}
        routeBack='/releases'
      />
      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            {/* INICIO PRODUCT NAME */}
            <Input
              title={intl.formatMessage({id: 'RELEASES.INPUT_PRODUCT_NAME'})}
              placeholder={intl.formatMessage({id: 'RELEASES.INPUT_PRODUCT_NAME'})}
              {...formik.getFieldProps('product_name')}
              required
            />
            {/* FIM PRODUCT NAME */}

            {/* INICIO RELEASE VERSION */}

            <Input
              title={intl.formatMessage({id: 'RELEASES.INPUT_RELEASE_VERSION'})}
              placeholder={intl.formatMessage({id: 'RELEASES.INPUT_RELEASE_VERSION'})}
              {...formik.getFieldProps('release_version')}
              required
            />
            {/* FIM RELEASE VERSION */}

            {/* INICIO OVERVIEW */}
            <Input
              title={intl.formatMessage({id: 'RELEASES.INPUT_OVERVIEW'})}
              placeholder={intl.formatMessage({id: 'RELEASES.INPUT_OVERVIEW'})}
              {...formik.getFieldProps('overview')}
              required
            />

            {/* FIM OVERVIEW */}

            {/* INICIO IMPACTS */}
            <Input
              title={intl.formatMessage({id: 'RELEASES.INPUT_IMPACTS'})}
              placeholder={intl.formatMessage({id: 'RELEASES.INPUT_IMPACTS'})}
              {...formik.getFieldProps('impacts')}
            />
            {/* FIM IMPACTS */}

            {/* INICIOISSUE_SUMMARY */}
            <Input
              title={intl.formatMessage({id: 'RELEASES.INPUT_ISSUE_SUMMARY'})}
              placeholder={intl.formatMessage({id: 'RELEASES.INPUT_ISSUE_SUMMARY'})}
              {...formik.getFieldProps('issue_summary')}
            />
            {/* FIM ISSUE_SUMMARY */}

            {/* INICIO NOTE */}
            <Input
              title={intl.formatMessage({id: 'RELEASES.INPUT_NOTE'})}
              placeholder={intl.formatMessage({id: 'RELEASES.INPUT_NOTE'})}
              {...formik.getFieldProps('note')}
            />
            {/* FIM NOTE */}

            {/* INICIO LINK */}
            <Input
              title={intl.formatMessage({id: 'RELEASES.INPUT_LINK'})}
              placeholder={intl.formatMessage({id: 'RELEASES.INPUT_LINK'})}
              {...formik.getFieldProps('link')}
            />
            {/* FIM LINK */}

            <div className='d-flex justify-content-end py-6'>
              <button type='submit' className='btn btn-primary' disabled={loading}>
                {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <button type='reset' onClick={resetInputs} className='btn btn-secondary  mx-2'>
                {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {FormReleasesAdd}
